import BannerForm from 'forms/BannerForm';

export default (): JSX.Element => <BannerForm />;
